module.exports = __webpack_public_path__ + "fonts/dm-sans-v6-latin-italic.60bc34c.woff2";